import React from 'react';
import Layout from '../components/Global/Layout/Layout';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Col, Row } from 'react-bootstrap';
import styles from '../components/Page-CSS/privacyPolicy.module.css';
import { MARKS, INLINES, BLOCKS } from '@contentful/rich-text-types';
import addedStyles from '../components/Page-CSS/productCategoriesTemplate.module.css';
import SEO from '../components/Global/SEO';
import { graphql } from 'gatsby';

export const query = graphql`
	{
		allContentfulPrivacyPolicyPage {
			nodes {
				metaDescription
				metaImage {
					fluid {
						src
					}
				}
				content {
					json
				}
			}
		}
	}
`;

const website_url = 'https://rayrue-private-final.netlify.app/';

const Bold = ({ children }) => <p className={styles.bold}>{children}</p>;
const Text = ({ children }) => <p className={styles.p}>{children}</p>;

export default function Privacypolicy({ data }) {
	const options = {
		renderMark: {
			[MARKS.BOLD]: (text) => <Bold>{text}</Bold>
		},
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
			'embedded-asset-block': (node) => {
				return (
					<img
						src={node.data.target.fields.file['en-US'].url}
						className={styles.img}
						alt={node.data.target.fields.title['en-US']}
					/>
				);
			},
			[INLINES.HYPERLINK]: (node) => {
				if (node.data.uri.indexOf('youtube.com') !== -1) {
					return (
						<div className={styles.videoHolder}>
							<iframe
								id="ytplayer"
								src={node.data.uri}
								type="text/html"
								width="640"
								height="360"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture ; fullscreen"
							/>
						</div>
					);
				} else
					return (
						<a
							href={node.data.uri}
							target={`${node.data.uri.startsWith(website_url) ? '_self' : '_blank'}`}
							rel={`${node.data.uri.startsWith(website_url) ? '' : 'noopener noreferrer'}`}
						>
							{node.content[0].value}
						</a>
					);
			}
		}
	};

	const { json } = data.allContentfulPrivacyPolicyPage.nodes[0].content;

	const { metaDescription, metaImage: { fluid: { src } } } = data.allContentfulPrivacyPolicyPage.nodes[0];

	return (
		<Layout>
			<SEO title="Privacy Policy" description={metaDescription} image={src} />
			<Col>
				<Row
					className={addedStyles.descriptionHolder}
					style={{ borderBottom: '1px solid rgba(128, 128, 128, 0.76)', marginBottom: '1rem' }}
				>
					<Col xs={12} sm={6} className={addedStyles.description}>
						<h1>Privacy Policy</h1>
						<p>
							We care about protecting your data and only using it enhance your shopping experience with
							your consent
						</p>
					</Col>
				</Row>
				<Row className={styles.row}>
					<Col xs={12} md={10} className={styles.content}>
						{documentToReactComponents(json, options)}
					</Col>
				</Row>
			</Col>
		</Layout>
	);
}
